import { FC, useCallback } from 'react';
import { Redirect, Route, RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom';
import appState from '../../state/AppStateContainer';
import SupplierEvaluationReview from './SupplierEvaluationReview';
import RequestStatusPage from './RequestStatusPage';

export const PageSupplierEvaluations: FC = () => {
  const { path, url } = useRouteMatch();
  const registerUrl = `${appState._getCurrentOrgUrl()}/supplier-database`;
  const statusUrlOf = useCallback((requestId: string) => `${url}/requests/${requestId}`, [url]);
  const reviewUrlOf = (supplierId: string) => `${url}/suppliers/${supplierId}`;

  return (
    <Switch>
      <Route
        exact
        path={`${path}/suppliers/:supplierId`}
        render={({ match }: RouteComponentProps<{ supplierId: string }>) => (
          <SupplierEvaluationReview
            key={match.params.supplierId}
            supplierId={match.params.supplierId}
            registerUrl={registerUrl}
            statusUrlOf={statusUrlOf}
          />
        )}
      />
      <Route
        exact
        path={`${path}/requests/:requestId`}
        render={({ match }: RouteComponentProps<{ requestId: string }>) => (
          <RequestStatusPage
            key={match.params.requestId}
            requestId={match.params.requestId}
            registerUrl={registerUrl}
            reviewUrlOf={reviewUrlOf}
          />
        )}
      />
      <Redirect to={registerUrl} />
    </Switch>
  );
};
